/**
 * Stable DOM id + URL hash fragment for email-analysis history steps / thread messages.
 * Restricts to [a-zA-Z0-9_-] so ids stay valid for getElementById / :target.
 * @param {string} [emailMessageId]
 * @param {number} [stepFallback] — disambiguate when id missing
 */
export function emailAnalysisStepDomId(emailMessageId, stepFallback) {
  const safe = String(emailMessageId || "").replace(/[^a-zA-Z0-9_-]/g, "_");
  if (safe) return `ea-msg-${safe}`;
  if (stepFallback != null && stepFallback !== "") return `ea-msg-step-${stepFallback}`;
  return "ea-msg-unknown";
}
